// import React, { useState, useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { UserAttendance, UserLeave } from '../../../../services/oprations/User_Bussiness_Logic';
// import {
//   Clock, TrendingUp, Calendar, User, Briefcase,
//   Award, AlertCircle, ChevronDown, ChevronUp,
//   BarChart2, Activity, MessageSquare, Star,
//   Zap, Target, CheckCircle, Bell,
//   PieChart, Layers
// } from 'lucide-react';

// const Analytics = () => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [hoveredDay, setHoveredDay] = useState(null);
//   const [dateRange, setDateRange] = useState({ from: '', to: '' });

//   const { userDetails } = useSelector(s => s.employeeAuth?.data || s.employeeAuth || {});
//   const { userAttendanceData } = useSelector(s => s.userAttendance?.data || s.userAttendance || []);
//   const { leaveData } = useSelector(s => s.userLeave?.data || s.userLeave || []);

//   const attendanceData = userAttendanceData || [];
//   const leaveRequests = leaveData || [];
//   const token = localStorage.getItem('token');

//   // Initialize date range to current month (1st to last day)
//   useEffect(() => {
//     const today = new Date();
//     const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
//     const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
//     setDateRange({
//       from: firstDay.toISOString().split('T')[0],
//       to: new Intl.DateTimeFormat('en-CA', {
//             timeZone: 'Pacific/Kiritimati',
//             year: 'numeric',
//             month: '2-digit',
//             day: '2-digit',
//           }).format(today),
//     });
//   }, []);

//   // Fetch attendance when date range changes
//   useEffect(() => {
//     if (token && dateRange.from && dateRange.to) {
//       fetchData();
//     }
//   }, [dateRange.from, dateRange.to, token]);

//   const fetchData = async () => {
//     setLoading(true);
//     await dispatch(UserAttendance(dateRange.from, dateRange.to, token));
//     await dispatch(UserLeave(token));
//     setLoading(false);
//   };

//   const handleDateChange = (type, value) => {
//     setDateRange(prev => ({ ...prev, [type]: value }));
//   };

//   const toDateStr = (val) => {
//     if (!val) return '';
//     if (val instanceof Date) return val.toISOString().slice(0, 10);
//     const s = String(val);
//     if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
//     return s.slice(0, 10);
//   };

//   const getDatesInRange = (from, to) => {
//     const dates = [];
//     const end = new Date(to);
//     for (let d = new Date(from); d <= end; d.setDate(d.getDate() + 1)) {
//       dates.push(new Date(d).toISOString().slice(0, 10));
//     }
//     return dates;
//   };

//   // Client‑side filtering to enforce the selected date range
//   const filteredAttendance = useMemo(() => {
//     if (!attendanceData.length || !dateRange.from || !dateRange.to) return [];
//     const fromDate = new Date(dateRange.from);
//     const toDate = new Date(dateRange.to);
//     return attendanceData.filter(record => {
//       const recDate = new Date(toDateStr(record.DateString));
//       return recDate >= fromDate && recDate <= toDate;
//     });
//   }, [attendanceData, dateRange.from, dateRange.to]);

//   const processAttendance = () => {
//     if (!dateRange.from || !dateRange.to) {
//       return {
//         dailyData: [], presentDays: 0, totalDaysConsidered: 0, attendancePct: 0,
//         absentDays: 0, leaveDays: 0, holidayDays: 0, lateDays: 0, onTimeDays: 0,
//         onTimePct: 0, totalWorkHours: '0', totalOvertime: '0'
//       };
//     }

//     const allDates = getDatesInRange(dateRange.from, dateRange.to);
//     const todayStr = new Date().toISOString().slice(0, 10);
//     // Only days up to today are considered for stats (no future data)
//     const consideredDates = allDates.filter(d => d <= todayStr);
//     const totalDaysConsidered = consideredDates.length;

//     // Build detailed daily data for heatmap (including future and weekend)
//     const detailedDailyData = allDates.map(date => {
//       const isFuture = date > todayStr;
//       const record = filteredAttendance.find(r => toDateStr(r.DateString) === date);
//       let workHours = 0, status = 'A', remark = null, inTime = null, outTime = null, lateBy = null;
//       let isWeekend = new Date(date).getDay() === 0 || new Date(date).getDay() === 6;

//       if (record) {
//         status = record.status;
//         remark = record.Remark || null;
//         inTime = record.IN_Time || null;
//         outTime = record.OUT_Time || null;
//         lateBy = (record.Late_In && record.Late_In !== '00:00' && record.Late_In !== '00:00:00') ? record.Late_In : null;
//         if (record.Work_Time && record.Work_Time !== '00:00') {
//           const [h, m] = record.Work_Time.split(':');
//           workHours = (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
//         }
//       } else if (isFuture) {
//         status = 'UPCOMING';
//       } else if (isWeekend) {
//         status = 'WEEKEND';
//       } else {
//         status = 'A'; // absent
//       }

//       return {
//         day: new Date(date).getDate(),
//         date,
//         status,
//         workHours,
//         isWeekend: status === 'WEEKEND', // for styling
//         isFuture,
//         remark,
//         inTime,
//         outTime,
//         lateBy
//       };
//     });

//     // Stats only from days <= today (excluding weekends and upcoming)
//     const statsDays = detailedDailyData.filter(d => !d.isFuture && d.status !== 'WEEKEND' && d.status !== 'UPCOMING');
//     const presentDays = statsDays.filter(d => d.status === 'P' || (d.lateBy && d.lateBy !== '00:00')).length;
//     const leaveDays = statsDays.filter(d => d.status === 'L').length;
//     const holidayDays = statsDays.filter(d => d.status === 'H').length;
//     const absentDays = statsDays.filter(d => d.status === 'A').length;
//     const attendancePct = totalDaysConsidered > 0 ? +((presentDays / totalDaysConsidered) * 100).toFixed(1) : 0;

//     // Late days = present days where arrival was late
//     const lateDays = filteredAttendance.filter(r =>
//       r.status === 'P' && r.Late_In && r.Late_In !== '00:00' && r.Late_In !== '00:00:00'
//     ).length;

//     const onTimeArrivals = presentDays - lateDays;
//     const scheduledDays = totalDaysConsidered - holidayDays;
//     const punctualityPct = scheduledDays > 0 ? +((onTimeArrivals / scheduledDays) * 100).toFixed(1) : 0;

//     const totalWorkHours = filteredAttendance.reduce((t, r) => {
//       if (!r.Work_Time) return t;
//       const [h, m] = r.Work_Time.split(':');
//       return t + (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
//     }, 0);

//     const totalOvertime = filteredAttendance.reduce((t, r) => {
//       if (!r.Over_Time) return t;
//       const ot = r.Over_Time;
//       if (ot === '00:00' || ot === '00:00:00') return t;
//       const [h, m] = ot.split(':');
//       const hours = (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
//       return t + Math.max(0, hours);
//     }, 0);

//     return {
//       presentDays, absentDays, leaveDays, holidayDays,
//       totalDaysConsidered, attendancePct,
//       lateDays, onTimeDays: onTimeArrivals, onTimePct: punctualityPct,
//       totalWorkHours: totalWorkHours.toFixed(1),
//       totalOvertime: totalOvertime.toFixed(1),
//       dailyData: detailedDailyData,
//     };
//   };

//   const processLeave = () => {
//     const approved = leaveRequests.filter(l => l.status?.toUpperCase() === 'APPROVED');
//     const totalTaken = approved.reduce((s, l) => s + (l.days || 0), 0);
//     return {
//       totalTaken, leaveBalance: userDetails?.leaveBalance || 0,
//       pendingCount: leaveRequests.filter(l => l.status?.toUpperCase() === 'PENDING').length,
//       rejectedCount: leaveRequests.filter(l => l.status?.toUpperCase() === 'REJECTED').length,
//       approvedCount: approved.length,
//       byType: {
//         'Annual Leave': approved.filter(l => l.leaveType === 'Annual Leave').reduce((s, l) => s + (l.days || 0), 0),
//         'Sick Leave': approved.filter(l => l.leaveType === 'Sick Leave').reduce((s, l) => s + (l.days || 0), 0),
//         'Casual Leave': approved.filter(l => l.leaveType === 'Casual Leave').reduce((s, l) => s + (l.days || 0), 0),
//       }
//     };
//   };

//   const getWeekly = () => {
//     const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
//     const perf = Object.fromEntries(days.map(d => [d, { present: 0, late: 0, workHours: 0 }]));

//     filteredAttendance.forEach(r => {
//       if (!r.DateString) return;
//       const d = new Date(toDateStr(r.DateString));
//       let dayIndex = d.getDay() === 0 ? 6 : d.getDay() - 1;
//       const dn = days[dayIndex];
//       if (r.status === 'P' || (r.Late_In && r.Late_In !== '00:00')) {
//         perf[dn].present++;
//         perf[dn].workHours += r.Work_Time ? parseFloat(r.Work_Time.split(':')[0]) : 0;
//         if (r.Late_In && r.Late_In !== '00:00' && r.Late_In !== '00:00:00') perf[dn].late++;
//       }
//     });
//     return perf;
//   };

//   const att = processAttendance();
//   const leave = processLeave();
//   const weekly = getWeekly();

//   const getScoreColor = (score) => {
//     if (score >= 90) return { text: 'text-emerald-600 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-500/10' };
//     if (score >= 75) return { text: 'text-amber-600 dark:text-amber-400', bg: 'bg-amber-50 dark:bg-amber-500/10' };
//     return { text: 'text-red-600 dark:text-red-400', bg: 'bg-red-50 dark:bg-red-500/10' };
//   };
//   const attendanceScore = att.attendancePct;
//   const scoreColor = getScoreColor(attendanceScore);

//   const StatCard = ({ icon: Icon, label, value, unit, sub, color, gradient }) => (
//     <div className="relative p-4 overflow-hidden transition-all duration-300 bg-white border border-gray-100 shadow-sm group rounded-2xl dark:bg-gray-900 hover:shadow-xl hover:-translate-y-1 dark:border-gray-800 sm:p-6">
//       <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
//       <div className="relative">
//         <div className={`inline-flex rounded-xl ${color.bg} p-2 mb-3 sm:p-2.5 sm:mb-4`}>
//           <Icon className={`w-4 h-4 sm:w-5 sm:h-5 ${color.text}`} strokeWidth={1.5} />
//         </div>
//         <p className="mb-1 text-xs font-medium tracking-wider text-gray-400 uppercase dark:text-gray-500">{label}</p>
//         <div className="flex items-baseline gap-1 mb-1">
//           <span className="text-2xl font-bold text-gray-900 dark:text-white sm:text-3xl">{value}</span>
//           <span className="text-xs text-gray-400 dark:text-gray-500 sm:text-sm">{unit}</span>
//         </div>
//         <p className="text-xs text-gray-400 dark:text-gray-500">{sub}</p>
//       </div>
//     </div>
//   );

//   const fromDisplay = dateRange.from ? new Date(dateRange.from).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
//   const toDisplay = dateRange.to ? new Date(dateRange.to).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';

//   // Helper to get color class based on status
//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'P': return 'bg-emerald-500 hover:bg-emerald-600';
//       case 'A': return 'bg-red-500 hover:bg-red-600';
//       case 'L': return 'bg-purple-500 hover:bg-purple-600';
//       case 'H': return 'bg-cyan-500 hover:bg-cyan-600';
//       case 'WEEKEND': return 'bg-gray-500 dark:bg-gray-700';
//       case 'UPCOMING': return 'bg-gray-300 dark:bg-gray-400';
//       default: return 'bg-gray-300 dark:bg-gray-600';
//     }
//   };

//   const getStatusText = (status) => {
//     switch (status) {
//       case 'P': return 'Present';
//       case 'A': return 'Absent';
//       case 'L': return 'Leave';
//       case 'H': return 'Holiday';
//       case 'WEEKEND': return 'Weekend';
//       case 'UPCOMING': return 'Upcoming';
//       default: return '—';
//     }
//   };

//   return (
//     // <div className="min-h-screen transition-colors duration-300 bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-black dark:via-gray-900 dark:to-black">
//     //   <div className="fixed inset-0 pointer-events-none opacity-5">
//     //     <div className="absolute inset-0 dark:opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #F97316 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
//     //   </div>

//       <div className="relative px-3 py-4 mx-auto max-w-7xl sm:px-6 sm:py-6 lg:px-8">
//         {/* Header with date range pickers */}
//         <div className="mb-6 sm:mb-8">
//           <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
//             <div>
//               <h1 className="text-2xl font-bold text-transparent bg-gradient-to-r from-orange-600 to-amber-600 dark:from-orange-400 dark:to-amber-400 bg-clip-text sm:text-3xl">
//                 Analytics
//               </h1>
//               <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 sm:text-base">
//                 {fromDisplay} — {toDisplay}
//               </p>
//             </div>
//             <div className="flex flex-wrap gap-3">
//               <input
//                 type="date"
//                 value={dateRange.from}
//                 onChange={(e) => handleDateChange('from', e.target.value)}
//                 className="px-3 py-1.5 text-sm font-medium text-gray-700 transition-all duration-200 bg-white border border-gray-200 dark:bg-gray-900 dark:border-gray-700 rounded-xl dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
//                 max={dateRange.to}
//               />
//               <span className="self-center text-gray-500">to</span>
//               <input
//                 type="date"
//                 value={dateRange.to}
//                 onChange={(e) => handleDateChange('to', e.target.value)}
//                 className="px-3 py-1.5 text-sm font-medium text-gray-700 transition-all duration-200 bg-white border border-gray-200 dark:bg-gray-900 dark:border-gray-700 rounded-xl dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
//                 min={dateRange.from}
//                 max={new Intl.DateTimeFormat('en-CA', {
//                   timeZone: 'Pacific/Kiritimati',
//                   year: 'numeric',
//                   month: '2-digit',
//                   day: '2-digit',
//                 }).format(new Date())}
//               />
//             </div>
//           </div>
//         </div>

//         {/* <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}> */}
//         <div>
//           {loading ? (
//             <div className="flex items-center justify-center h-96">
//               <div className="relative">
//                 <div className="w-12 h-12 border-4 border-orange-200 rounded-full dark:border-orange-800 border-t-orange-600 dark:border-t-orange-400 animate-spin sm:w-16 sm:h-16"></div>
//                 <div className="absolute inset-0 flex items-center justify-center">
//                   <Zap className="w-5 h-5 text-orange-600 dark:text-orange-400 animate-pulse sm:w-6 sm:h-6" />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <>
//               {/* Stats Grid - same as before */}
//               <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-2 sm:gap-5 sm:mb-8 lg:grid-cols-4">
//                 <StatCard
//                   icon={CheckCircle}
//                   label="Attendance Rate"
//                   value={att.attendancePct}
//                   unit="%"
//                   sub={`${att.presentDays} days present`}
//                   color={{ bg: 'bg-emerald-50 dark:bg-emerald-500/10', text: 'text-emerald-600 dark:text-emerald-400' }}
//                   gradient="from-emerald-500 to-teal-500"
//                 />
//                 <StatCard
//                   icon={Target}
//                   label="Punctuality"
//                   value={att.onTimePct}
//                   unit="%"
//                   sub={`${att.onTimeDays} on-time arrivals`}
//                   color={{ bg: 'bg-blue-50 dark:bg-blue-500/10', text: 'text-blue-600 dark:text-blue-400' }}
//                   gradient="from-blue-500 to-cyan-500"
//                 />
//                 <StatCard
//                   icon={Clock}
//                   label="Work Hours"
//                   value={att.totalWorkHours}
//                   unit="hrs"
//                   sub={`${att.totalOvertime} hrs overtime`}
//                   color={{ bg: 'bg-purple-50 dark:bg-purple-500/10', text: 'text-purple-600 dark:text-purple-400' }}
//                   gradient="from-purple-500 to-pink-500"
//                 />
//                 <StatCard
//                   icon={Calendar}
//                   label="Leave Balance"
//                   value={leave.leaveBalance}
//                   unit="days"
//                   sub={`${leave.totalTaken} used (overall)`}
//                   color={{ bg: 'bg-orange-50 dark:bg-orange-500/10', text: 'text-orange-600 dark:text-orange-400' }}
//                   gradient="from-orange-500 to-amber-500"
//                 />
//               </div>

//               {/* Employee Profile Card */}
//               <div className="p-4 mb-6 transition-all duration-300 bg-white border border-gray-100 shadow-sm dark:bg-gray-900 rounded-2xl dark:border-gray-800 sm:p-6 sm:mb-8">
//                 <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
//                   <div className="relative">
//                     <div className="flex items-center justify-center w-16 h-16 text-xl font-bold text-white rounded-full shadow-lg bg-gradient-to-br from-orange-500 to-amber-600 sm:w-20 sm:h-20 sm:text-2xl">
//                       {userDetails?.user_name?.charAt(0) || 'U'}
//                     </div>
//                     <div className="absolute w-4 h-4 bg-green-500 border-2 border-white rounded-full -bottom-1 -right-1 dark:border-gray-900 sm:w-5 sm:h-5"></div>
//                   </div>
//                   <div className="flex-1 text-center sm:text-left">
//                     <h2 className="text-lg font-bold text-gray-900 dark:text-white sm:text-xl">{userDetails?.user_name || 'Employee'}</h2>
//                     <div className="flex flex-wrap justify-center gap-3 mt-1 sm:justify-start sm:gap-4 sm:mt-2">
//                       <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 sm:gap-2 sm:text-sm">
//                         <Briefcase size={14} /> {userDetails?.user_department || 'Department'}
//                       </div>
//                       <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 sm:gap-2 sm:text-sm">
//                         <Award size={14} /> ID: {userDetails?.user_roll || 'N/A'}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="w-full sm:w-auto">
//                     <div className={`inline-flex items-center justify-center w-full gap-2 px-3 py-1.5 ${scoreColor.bg} rounded-xl sm:px-4 sm:py-2`}>
//                       <Star size={14} className={scoreColor.text} />
//                       <span className={`text-xs font-medium ${scoreColor.text} sm:text-sm`}>Performance Score</span>
//                       <span className={`text-base font-bold ${scoreColor.text} sm:text-lg`}>{attendanceScore}%</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Monthly Overview with Metrics */}
//               <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-3 sm:gap-6 sm:mb-8">
//                 <div className="p-4 transition-all duration-300 bg-white border border-gray-100 shadow-sm lg:col-span-2 dark:bg-gray-900 rounded-2xl dark:border-gray-800 sm:p-6">
//                   <div className="flex items-center gap-2 mb-4 sm:mb-6">
//                     <TrendingUp size={18} className="text-orange-500 dark:text-orange-400" />
//                     <h3 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">Range Performance</h3>
//                   </div>
//                   <div className="space-y-4 sm:space-y-5">
//                     <div>
//                       <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
//                         <span className="text-gray-600 dark:text-gray-400">Attendance Rate</span>
//                         <span className="font-semibold text-gray-900 dark:text-white">{att.attendancePct}%</span>
//                       </div>
//                       <div className="h-1.5 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-800 sm:h-2">
//                         <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500" style={{ width: `${att.attendancePct}%` }}></div>
//                       </div>
//                     </div>
//                     <div>
//                       <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
//                         <span className="text-gray-600 dark:text-gray-400">Punctuality (on‑time arrivals)</span>
//                         <span className="font-semibold text-gray-900 dark:text-white">{att.onTimePct}%</span>
//                       </div>
//                       <div className="h-1.5 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-800 sm:h-2">
//                         <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500" style={{ width: `${att.onTimePct}%` }}></div>
//                       </div>
//                     </div>
//                     <div>
//                       <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
//                         <span className="text-gray-600 dark:text-gray-400">Leave Utilization (overall)</span>
//                         <span className="font-semibold text-gray-900 dark:text-white">{Math.min((leave.totalTaken / Math.max(leave.totalTaken + leave.leaveBalance, 1)) * 100, 100).toFixed(1)}%</span>
//                       </div>
//                       <div className="h-1.5 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-800 sm:h-2">
//                         <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-orange-500 to-amber-500" style={{ width: `${Math.min((leave.totalTaken / Math.max(leave.totalTaken + leave.leaveBalance, 1)) * 100, 100)}%` }}></div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="p-4 text-white transition-all duration-300 shadow-sm bg-gradient-to-br from-orange-500 to-amber-600 dark:from-orange-600 dark:to-amber-700 rounded-2xl sm:p-6">
//                   <div className="flex items-center gap-2 mb-3 sm:mb-4">
//                     <Zap size={18} className="text-orange-200" />
//                     <h3 className="text-base font-semibold sm:text-lg">Quick Stats</h3>
//                   </div>
//                   <div className="space-y-3 sm:space-y-4">
//                     <div>
//                       <p className="text-xs text-orange-100 sm:text-sm">Present Days</p>
//                       <p className="text-2xl font-bold sm:text-3xl">{att.presentDays} <span className="text-base text-orange-200 sm:text-lg">/ {att.totalDaysConsidered}</span></p>
//                     </div>
//                     <div>
//                       <p className="text-xs text-orange-100 sm:text-sm">Total Work Hours</p>
//                       <p className="text-xl font-bold sm:text-2xl">{att.totalWorkHours} hrs</p>
//                     </div>
//                     <div>
//                       <p className="text-xs text-orange-100 sm:text-sm">Overtime</p>
//                       <p className="text-xl font-bold sm:text-2xl">{att.totalOvertime} hrs</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Daily Activity Heatmap - now shows ALL days in range */}
//               <div className="p-3 mb-6 transition-all duration-300 bg-white border border-gray-100 shadow-sm dark:bg-gray-900 rounded-2xl dark:border-gray-800 sm:p-4 sm:mb-8 md:p-6">
//                 <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between sm:mb-6">
//                   <div className="flex items-center gap-2">
//                     <Calendar size={18} className="text-orange-500 dark:text-orange-400" />
//                     <h3 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">Daily Activity Heatmap</h3>
//                   </div>
//                   <div className="flex flex-wrap gap-2 text-xs sm:gap-3">
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 rounded bg-emerald-500"></div><span>Present</span></div>
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-red-500 rounded"></div><span>Absent</span></div>
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-purple-500 rounded"></div><span>Leave</span></div>
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-cyan-500 rounded"></div><span>Holiday</span></div>
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-gray-400 rounded"></div><span>Weekend</span></div>
//                     <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-gray-300 dark:bg-gray-700 rounded"></div><span>Upcoming</span></div>
//                   </div>
//                 </div>

//                 {att.dailyData.length === 0 ? (
//                   <div className="py-12 text-center">
//                     <p className="text-gray-500 dark:text-gray-400">No attendance data available for the selected period.</p>
//                   </div>
//                 ) : (
//                   <div>
//                     <div className="grid grid-cols-7 gap-1 min-w-[280px] sm:gap-1.5 md:gap-2">
//                       {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
//                         <div key={day} className="py-1 text-[10px] font-medium text-center text-gray-500 dark:text-gray-400 sm:py-2 sm:text-xs">{day}</div>
//                       ))}
//                       {(() => {
//                         const sortedDays = [...att.dailyData].sort((a, b) => new Date(a.date) - new Date(b.date));
//                         if (sortedDays.length === 0) return null;
//                         const startDate = new Date(sortedDays[0].date);
//                         const blanks = Array(startDate.getDay()).fill(null);
//                         const calendarDays = [...blanks, ...sortedDays];
//                         return calendarDays.map((d, index) => {
//                           if (!d) return <div key={`empty-${index}`} className="p-1 rounded-lg bg-gray-50 dark:bg-gray-800/50 sm:p-2"></div>;
//                           const bgColor = getStatusColor(d.status);
//                           const statusText = getStatusText(d.status);
//                           return (
//                             <div
//                               key={`day-${d.day}-${index}`}
//                               className={`${bgColor} rounded-lg p-1 text-center transition-all duration-200 hover:scale-105 cursor-pointer shadow-sm relative group sm:p-1.5 md:p-2`}
//                               onMouseEnter={() => setHoveredDay(d)}
//                               onMouseLeave={() => setHoveredDay(null)}
//                               onClick={() => setHoveredDay(d)}
//                             >
//                               <div className="text-xs font-semibold text-white sm:text-sm">{d.day}</div>
//                               <div className="absolute z-10 px-2 py-1 mb-1 text-xs text-white transition-opacity duration-200 transform -translate-x-1/2 bg-gray-900 rounded-lg opacity-0 pointer-events-none bottom-full left-1/2 dark:bg-gray-800 group-hover:opacity-100 whitespace-nowrap">
//                                 {statusText}
//                                 {d.workHours > 0 && ` • ${d.workHours.toFixed(1)}h`}
//                                 {d.lateBy && ` • Late: ${d.lateBy}`}
//                               </div>
//                             </div>
//                           );
//                         });
//                       })()}
//                     </div>
//                   </div>
//                 )}

//                 {/* Hover Details Card */}
//                 {hoveredDay && (
//                   <div className="p-3 mt-4 border border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800/50 dark:to-gray-800/30 rounded-xl animate-fade-in dark:border-gray-700 sm:p-4">
//                     <div className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center sm:justify-between">
//                       <p className="text-sm font-semibold text-gray-900 dark:text-white sm:text-base">
//                         {new Date(hoveredDay.date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
//                       </p>
//                       <span className={`self-start px-2 py-0.5 rounded-full text-xs font-medium sm:self-auto ${
//                         hoveredDay.status === 'P' ? 'bg-emerald-100 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-400' :
//                         hoveredDay.status === 'A' ? 'bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-400' :
//                         hoveredDay.status === 'L' ? 'bg-purple-100 dark:bg-purple-500/20 text-purple-700 dark:text-purple-400' :
//                         hoveredDay.status === 'H' ? 'bg-cyan-100 dark:bg-cyan-500/20 text-cyan-700 dark:text-cyan-400' :
//                         'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400'
//                       }`}>
//                         {getStatusText(hoveredDay.status)}
//                       </span>
//                     </div>
//                     <div className="grid grid-cols-2 gap-3 mt-3 text-sm sm:grid-cols-4">
//                       {hoveredDay.inTime && (
//                         <div className="flex items-center gap-2">
//                           <Clock size={14} className="text-gray-400 dark:text-gray-500" />
//                           <div>
//                             <p className="text-xs text-gray-500 dark:text-gray-400">Check In</p>
//                             <p className="font-medium text-gray-700 dark:text-gray-300">{hoveredDay.inTime}</p>
//                           </div>
//                         </div>
//                       )}
//                       {hoveredDay.outTime && (
//                         <div className="flex items-center gap-2">
//                           <Clock size={14} className="text-gray-400 dark:text-gray-500" />
//                           <div>
//                             <p className="text-xs text-gray-500 dark:text-gray-400">Check Out</p>
//                             <p className="font-medium text-gray-700 dark:text-gray-300">{hoveredDay.outTime}</p>
//                           </div>
//                         </div>
//                       )}
//                       {hoveredDay.workHours > 0 && (
//                         <div className="flex items-center gap-2">
//                           <TrendingUp size={14} className="text-gray-400 dark:text-gray-500" />
//                           <div>
//                             <p className="text-xs text-gray-500 dark:text-gray-400">Work Hours</p>
//                             <p className="font-medium text-gray-700 dark:text-gray-300">{hoveredDay.workHours.toFixed(1)}h</p>
//                           </div>
//                         </div>
//                       )}
//                       {hoveredDay.lateBy && (
//                         <div className="flex items-center gap-2">
//                           <AlertCircle size={14} className="text-amber-500" />
//                           <div>
//                             <p className="text-xs text-gray-500 dark:text-gray-400">Late By</p>
//                             <p className="font-medium text-amber-600 dark:text-amber-400">{hoveredDay.lateBy}</p>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     {hoveredDay.remark && (
//                       <div className="pt-3 mt-3 border-t border-gray-200 dark:border-gray-700">
//                         <p className="mb-1 text-xs text-gray-500 dark:text-gray-400">Remark</p>
//                         <p className="text-sm text-gray-700 dark:text-gray-300">{hoveredDay.remark}</p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Weekly Pattern & Leave Summary - unchanged */}
//               <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 sm:mb-8">
//                 <div className="p-4 transition-all duration-300 bg-white border border-gray-100 shadow-sm dark:bg-gray-900 rounded-2xl dark:border-gray-800 sm:p-6">
//                   <div className="flex items-center gap-2 mb-4 sm:mb-6">
//                     <PieChart size={18} className="text-orange-500 dark:text-orange-400" />
//                     <h3 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">Weekly Pattern</h3>
//                   </div>
//                   <div className="space-y-3 sm:space-y-4">
//                     {Object.entries(weekly).map(([day, data]) => (
//                       <div key={day}>
//                         <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
//                           <span className="font-medium text-gray-700 dark:text-gray-300">{day}</span>
//                           <span className="text-gray-500 dark:text-gray-400">{data.present} days • {data.late} late</span>
//                         </div>
//                         <div className="h-1.5 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-800 sm:h-2">
//                           <div className="h-full transition-all rounded-full bg-gradient-to-r from-orange-500 to-amber-500" style={{ width: `${Math.min((data.present / 5) * 100, 100)}%` }}></div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="p-4 transition-all duration-300 bg-white border border-gray-100 shadow-sm dark:bg-gray-900 rounded-2xl dark:border-gray-800 sm:p-6">
//                   <div className="flex items-center gap-2 mb-4 sm:mb-6">
//                     <Calendar size={18} className="text-orange-500 dark:text-orange-400" />
//                     <h3 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">Leave Breakdown</h3>
//                   </div>
//                   <div className="space-y-3 sm:space-y-4">
//                     {Object.entries(leave.byType).map(([type, days]) => days > 0 && (
//                       <div key={type}>
//                         <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
//                           <span className="text-gray-700 dark:text-gray-300">{type}</span>
//                           <span className="font-semibold text-gray-900 dark:text-white">{days} days</span>
//                         </div>
//                         <div className="h-1.5 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-800 sm:h-2">
//                           <div className="h-full rounded-full bg-gradient-to-r from-orange-400 to-amber-500" style={{ width: `${Math.min((days / 20) * 100, 100)}%` }}></div>
//                         </div>
//                       </div>
//                     ))}
//                     <div className="pt-3 mt-3 border-t border-gray-100 dark:border-gray-800 sm:pt-4 sm:mt-4">
//                       <div className="flex justify-between text-xs sm:text-sm">
//                         <span className="text-gray-600 dark:text-gray-400">Pending Requests</span>
//                         <span className="font-semibold text-amber-600 dark:text-amber-400">{leave.pendingCount}</span>
//                       </div>
//                       <div className="flex justify-between mt-1 text-xs sm:mt-2 sm:text-sm">
//                         <span className="text-gray-600 dark:text-gray-400">Approved Requests</span>
//                         <span className="font-semibold text-emerald-600 dark:text-emerald-400">{leave.approvedCount}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Alerts */}
//               {att.lateDays > 3 && (
//                 <div className="p-3 mb-4 transition-all duration-300 border bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border-amber-200 dark:border-amber-800 rounded-2xl sm:p-4 sm:mb-6">
//                   <div className="flex gap-2 sm:gap-3">
//                     <Bell className="flex-shrink-0 w-4 h-4 text-amber-600 dark:text-amber-400 sm:w-5 sm:h-5" />
//                     <div>
//                       <h4 className="mb-0.5 text-sm font-semibold text-amber-800 dark:text-amber-300 sm:mb-1 sm:text-base">Punctuality Alert</h4>
//                       <p className="text-xs text-amber-700 dark:text-amber-400 sm:text-sm">
//                         You've been late {att.lateDays} times in the selected period. Consider adjusting your morning routine.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {att.attendancePct >= 90 && att.lateDays === 0 && att.totalDaysConsidered > 0 && (
//                 <div className="p-3 mb-4 transition-all duration-300 border bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 border-emerald-200 dark:border-emerald-800 rounded-2xl sm:p-4 sm:mb-6">
//                   <div className="flex gap-2 sm:gap-3">
//                     <Award className="flex-shrink-0 w-4 h-4 text-emerald-600 dark:text-emerald-400 sm:w-5 sm:h-5" />
//                     <div>
//                       <h4 className="mb-0.5 text-sm font-semibold text-emerald-800 dark:text-emerald-300 sm:mb-1 sm:text-base">Outstanding Performance! 🎉</h4>
//                       <p className="text-xs text-emerald-700 dark:text-emerald-400 sm:text-sm">
//                         Perfect attendance with {att.attendancePct}% rate and zero late marks. Keep it up!
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>  
//       </div>
//   )
// }
// //     </div>
// //   );
// // };

// export default Analytics;



import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserAttendance, UserLeave } from '../../../../services/oprations/User_Bussiness_Logic';
import {
  Clock, TrendingUp, Calendar, Briefcase,
  Award, AlertCircle,
  Star,
  Zap, Target, CheckCircle, Bell,
  PieChart
} from 'lucide-react';
import { useTheme } from '../../../../Context/themeContext';

const Analytics = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hoveredDay, setHoveredDay] = useState(null);
  const [dateRange, setDateRange] = useState({ from: '', to: '' });

  const { userDetails } = useSelector(s => s.employeeAuth?.data || s.employeeAuth || {});
  const { userAttendanceData } = useSelector(s => s.userAttendance?.data || s.userAttendance || []);
  const { leaveData } = useSelector(s => s.userLeave?.data || s.userLeave || []);

  //const attendanceData = userAttendanceData || [];
  const attendanceData = useMemo(() => {
  return userAttendanceData || [];
}, [userAttendanceData]);
  const leaveRequests = leaveData || [];
  const token = localStorage.getItem('token');

  // ─── Theme-aware classes ──────────────────────────────────────────────────
  const bgPrimary = isDark ? 'bg-black' : 'bg-gray-50';
  const bgCard = isDark ? 'bg-gray-900' : 'bg-white/80';
  //const bgSection = isDark ? 'bg-richblue-800/20' : 'bg-gray-100/50';
  const bgInput = isDark ? 'bg-richblue-600/20' : 'bg-gray-100/80';
  //const bgBadge = isDark ? 'bg-blue-600/20' : 'bg-blue-100';
  
  const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  //const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-700/80' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-300' : 'text-gray-600';
  const textMuted = isDark ? 'text-blue-200/70' : 'text-gray-500';
  const textLight = isDark ? 'text-blue-300' : 'text-gray-700';
  const textPlaceholder = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';
  
  //const shadowColor = isDark ? 'shadow-blue-900/20' : 'shadow-gray-200';
  const hoverBg = isDark ? 'hover:bg-blue-800/30' : 'hover:bg-gray-100/50';
  
  const gradientText = isDark 
    ? 'from-blue-400 to-cyan-400'
    : 'from-blue-600 to-cyan-600';
  //const gradientBar = isDark ? 'from-blue-500 to-cyan-500': 'from-blue-500 to-cyan-500';
  
  const alertWarning = isDark 
    ? 'bg-yellow-900/20 border-yellow-800'
    : 'bg-yellow-100/20 border-yellow-200/20';
  const alertSuccess = isDark
    ? 'bg-green-900/20 border-green-800'
    : 'bg-green-50 border-green-200';

  // Initialize date range to current month
  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
    //const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    setDateRange({
      from: firstDay.toISOString().split('T')[0],
      to: new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Pacific/Kiritimati',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).format(today),
    });
  }, []);



  const fetchData =useCallback( async () => {
    setLoading(true);
    await dispatch(UserAttendance(dateRange.from, dateRange.to, token));
    await dispatch(UserLeave(token));
    setLoading(false);
  },[dateRange.from, dateRange.to, dispatch, token]);

    // Fetch attendance when date range changes
  useEffect(() => {
    if (token && dateRange.from && dateRange.to) {
      fetchData();
    }
  }, [dateRange.from, dateRange.to, token, fetchData]);

  const handleDateChange = (type, value) => {
    setDateRange(prev => ({ ...prev, [type]: value }));
  };

  const toDateStr = (val) => {
    if (!val) return '';
    if (val instanceof Date) return val.toISOString().slice(0, 10);
    const s = String(val);
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    return s.slice(0, 10);
  };

  const getDatesInRange = (from, to) => {
    const dates = [];
    const end = new Date(to);
    for (let d = new Date(from); d <= end; d.setDate(d.getDate() + 1)) {
      dates.push(new Date(d).toISOString().slice(0, 10));
    }
    return dates;
  };

  // Client‑side filtering to enforce the selected date range
  const filteredAttendance = useMemo(() => {
    if (!attendanceData.length || !dateRange.from || !dateRange.to) return [];
    const fromDate = new Date(dateRange.from);
    const toDate = new Date(dateRange.to);
    return attendanceData.filter(record => {
      const recDate = new Date(toDateStr(record.DateString));
      return recDate >= fromDate && recDate <= toDate;
    });
  }, [attendanceData, dateRange.from, dateRange.to]);

  const processAttendance = () => {
    if (!dateRange.from || !dateRange.to) {
      return {
        dailyData: [], presentDays: 0, totalDaysConsidered: 0, attendancePct: 0,
        absentDays: 0, leaveDays: 0, holidayDays: 0, lateDays: 0, onTimeDays: 0,
        onTimePct: 0, totalWorkHours: '0', totalOvertime: '0'
      };
    }

    const allDates = getDatesInRange(dateRange.from, dateRange.to);
    const todayStr = new Date().toISOString().slice(0, 10);
    const consideredDates = allDates.filter(d => d <= todayStr);
    const totalDaysConsidered = consideredDates.length;

    const detailedDailyData = allDates.map(date => {
      const isFuture = date > todayStr;
      const record = filteredAttendance.find(r => toDateStr(r.DateString) === date);
      let workHours = 0, status = 'A', remark = null, inTime = null, outTime = null, lateBy = null;
      let isWeekend = new Date(date).getDay() === 0 || new Date(date).getDay() === 6;

      if (record) {
        status = record.status;
        remark = record.Remark || null;
        inTime = record.IN_Time || null;
        outTime = record.OUT_Time || null;
        lateBy = (record.Late_In && record.Late_In !== '00:00' && record.Late_In !== '00:00:00') ? record.Late_In : null;
        if (record.Work_Time && record.Work_Time !== '00:00') {
          const [h, m] = record.Work_Time.split(':');
          workHours = (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
        }
      } else if (isFuture) {
        status = 'UPCOMING';
      } else if (isWeekend) {
        status = 'WEEKEND';
      } else {
        status = 'A';
      }

      return {
        day: new Date(date).getDate(),
        date,
        status,
        workHours,
        isWeekend: status === 'WEEKEND',
        isFuture,
        remark,
        inTime,
        outTime,
        lateBy
      };
    });

    const statsDays = detailedDailyData.filter(d => !d.isFuture && d.status !== 'WEEKEND' && d.status !== 'UPCOMING');
    const presentDays = statsDays.filter(d => d.status === 'P' || (d.lateBy && d.lateBy !== '00:00')).length;
    const leaveDays = statsDays.filter(d => d.status === 'L').length;
    const holidayDays = statsDays.filter(d => d.status === 'H').length;
    const absentDays = statsDays.filter(d => d.status === 'A').length;
    const attendancePct = totalDaysConsidered > 0 ? +((presentDays / totalDaysConsidered) * 100).toFixed(1) : 0;

    const lateDays = filteredAttendance.filter(r =>
      r.status === 'P' && r.Late_In && r.Late_In !== '00:00' && r.Late_In !== '00:00:00'
    ).length;

    const onTimeArrivals = presentDays - lateDays;
    const scheduledDays = totalDaysConsidered - holidayDays;
    const punctualityPct = scheduledDays > 0 ? +((onTimeArrivals / scheduledDays) * 100).toFixed(1) : 0;

    const totalWorkHours = filteredAttendance.reduce((t, r) => {
      if (!r.Work_Time) return t;
      const [h, m] = r.Work_Time.split(':');
      return t + (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
    }, 0);

    const totalOvertime = filteredAttendance.reduce((t, r) => {
      if (!r.Over_Time) return t;
      const ot = r.Over_Time;
      if (ot === '00:00' || ot === '00:00:00') return t;
      const [h, m] = ot.split(':');
      const hours = (parseInt(h) || 0) + (parseInt(m) || 0) / 60;
      return t + Math.max(0, hours);
    }, 0);

    return {
      presentDays, absentDays, leaveDays, holidayDays,
      totalDaysConsidered, attendancePct,
      lateDays, onTimeDays: onTimeArrivals, onTimePct: punctualityPct,
      totalWorkHours: totalWorkHours.toFixed(1),
      totalOvertime: totalOvertime.toFixed(1),
      dailyData: detailedDailyData,
    };
  };

  const processLeave = () => {
    const approved = leaveRequests.filter(l => l.status?.toUpperCase() === 'APPROVED');
    const totalTaken = approved.reduce((s, l) => s + (l.days || 0), 0);
    return {
      totalTaken, leaveBalance: userDetails?.leaveBalance || 0,
      pendingCount: leaveRequests.filter(l => l.status?.toUpperCase() === 'PENDING').length,
      rejectedCount: leaveRequests.filter(l => l.status?.toUpperCase() === 'REJECTED').length,
      approvedCount: approved.length,
      byType: {
        'Annual Leave': approved.filter(l => l.leaveType === 'Annual Leave').reduce((s, l) => s + (l.days || 0), 0),
        'Sick Leave': approved.filter(l => l.leaveType === 'Sick Leave').reduce((s, l) => s + (l.days || 0), 0),
        'Casual Leave': approved.filter(l => l.leaveType === 'Casual Leave').reduce((s, l) => s + (l.days || 0), 0),
      }
    };
  };

  const getWeekly = () => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const perf = Object.fromEntries(days.map(d => [d, { present: 0, late: 0, workHours: 0 }]));

    filteredAttendance.forEach(r => {
      if (!r.DateString) return;
      const d = new Date(toDateStr(r.DateString));
      let dayIndex = d.getDay() === 0 ? 6 : d.getDay() - 1;
      const dn = days[dayIndex];
      if (r.status === 'P' || (r.Late_In && r.Late_In !== '00:00')) {
        perf[dn].present++;
        perf[dn].workHours += r.Work_Time ? parseFloat(r.Work_Time.split(':')[0]) : 0;
        if (r.Late_In && r.Late_In !== '00:00' && r.Late_In !== '00:00:00') perf[dn].late++;
      }
    });
    return perf;
  };

  const att = processAttendance();
  const leave = processLeave();
  const weekly = getWeekly();

  const getScoreColor = (score) => {
    if (score >= 90) return { 
      text: isDark ? 'text-green-400' : 'text-green-600', 
      bg: isDark ? 'bg-green-500/10' : 'bg-green-50' 
    };
    if (score >= 75) return { 
      text: isDark ? 'text-yellow-400' : 'text-yellow-600', 
      bg: isDark ? 'bg-yellow-500/10' : 'bg-yellow-100/20' 
    };
    return { 
      text: isDark ? 'text-red-400' : 'text-red-600', 
      bg: isDark ? 'bg-red-500/10' : 'bg-red-100' 
    };
  };
  const attendanceScore = att.attendancePct;
  const scoreColor = getScoreColor(attendanceScore);

  const StatCard = ({ icon: Icon, label, value, unit, sub, color, gradient }) => (
    <div className={`relative p-4 overflow-hidden transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm group rounded-2xl ${hoverBg} hover:shadow-xl hover:-translate-y-1 sm:p-6`}>
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
      <div className="relative">
        <div className={`inline-flex rounded-xl ${color.bg} p-2 mb-3 sm:p-2.5 sm:mb-4`}>
          <Icon className={`w-4 h-4 sm:w-5 sm:h-5 ${color.text}`} strokeWidth={1.5} />
        </div>
        <p className={`mb-1 text-xs font-medium tracking-wider uppercase ${textSecondary}`}>{label}</p>
        <div className="flex items-baseline gap-1 mb-1">
          <span className={`text-2xl font-bold ${textPrimary} sm:text-3xl`}>{value}</span>
          <span className={`text-xs ${textMuted} sm:text-sm`}>{unit}</span>
        </div>
        <p className={`text-xs ${textMuted}`}>{sub}</p>
      </div>
    </div>
  );

  const fromDisplay = dateRange.from ? new Date(dateRange.from).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  const toDisplay = dateRange.to ? new Date(dateRange.to).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';

  const getStatusColor = (status) => {
    switch (status) {
      case 'P': return 'bg-green-600 hover:bg-green-700';
      case 'A': return 'bg-red-500 hover:bg-red-600';
      case 'L': return 'bg-purple-500 hover:bg-purple-600';
      case 'H': return 'bg-cyan-500 hover:bg-cyan-600';
      case 'WEEKEND': return isDark ? 'bg-gray-700' : 'bg-gray-500';
      case 'UPCOMING': return isDark ? 'bg-gray-800' : 'bg-gray-400';
      default: return isDark ? 'bg-gray-600' : 'bg-gray-300';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'P': return 'Present';
      case 'A': return 'Absent';
      case 'L': return 'Leave';
      case 'H': return 'Holiday';
      case 'WEEKEND': return 'Weekend';
      case 'UPCOMING': return 'Upcoming';
      default: return '—';
    }
  };

  const getStatusBadgeStyle = (status) => {
    switch (status) {
      case 'P': return isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-700';
      case 'A': return isDark ? 'bg-red-500/20 text-red-400' : 'bg-red-100 text-red-700';
      case 'L': return isDark ? 'bg-purple-500/20 text-purple-400' : 'bg-purple-100 text-purple-700';
      case 'H': return isDark ? 'bg-cyan-500/20 text-cyan-400' : 'bg-cyan-100 text-cyan-700';
      default: return isDark ? 'bg-gray-800 text-gray-400' : 'bg-gray-100 text-gray-700';
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${bgPrimary}`}>
      <div className="relative px-3 py-4 mx-auto max-w-7xl sm:px-6 sm:py-6 lg:px-8">
        {/* Header with date range pickers */}
        <div className="mb-6 sm:mb-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className={`text-2xl font-bold text-transparent bg-gradient-to-r ${gradientText} bg-clip-text sm:text-3xl`}>
                Analytics
              </h1>
              <p className={`mt-1 text-sm ${textSecondary} sm:text-base`}>
                {fromDisplay} — {toDisplay}
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <input
                type="date"
                value={dateRange.from}
                onChange={(e) => handleDateChange('from', e.target.value)}
                className={`px-3 py-1.5 text-sm font-medium transition-all duration-200 ${bgInput} border ${borderInput} rounded-xl ${textPrimary} ${textPlaceholder} focus:outline-none focus:ring-2 focus:ring-blue-700`}
                max={dateRange.to}
              />
              <span className={textSecondary}>to</span>
              <input
                type="date"
                value={dateRange.to}
                onChange={(e) => handleDateChange('to', e.target.value)}
                className={`px-3 py-1.5 text-sm font-medium transition-all duration-200 ${bgInput} border ${borderInput} rounded-xl ${textPrimary} ${textPlaceholder} focus:outline-none focus:ring-2 focus:ring-blue-700`}
                min={dateRange.from}
                max={new Intl.DateTimeFormat('en-CA', {
                  timeZone: 'Pacific/Kiritimati',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }).format(new Date())}
              />
            </div>
          </div>
        </div>

        <div>
          {loading ? (
            <div className="flex items-center justify-center h-96">
              <div className="relative">
                <div className={`w-12 h-12 border-4 ${isDark ? 'border-blue-800' : 'border-blue-200'} rounded-full border-t-blue-600 dark:border-t-blue-400 animate-spin sm:w-16 sm:h-16`}></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Zap className={`w-5 h-5 text-blue-600 dark:text-blue-400 animate-pulse sm:w-6 sm:h-6`} />
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Stats Grid */}
              <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-2 sm:gap-5 sm:mb-8 lg:grid-cols-4">
                <StatCard
                  icon={CheckCircle}
                  label="Attendance Rate"
                  value={att.attendancePct}
                  unit="%"
                  sub={`${att.presentDays} days present`}
                  color={{ bg: isDark ? 'bg-green-300/20' : 'bg-green-50', text: isDark ? 'text-green-400' : 'text-green-600' }}
                  gradient="from-green-500 to-teal-500"
                />
                <StatCard
                  icon={Target}
                  label="Punctuality"
                  value={att.onTimePct}
                  unit="%"
                  sub={`${att.onTimeDays} on-time arrivals`}
                  color={{ bg: isDark ? 'bg-blue-300/20' : 'bg-blue-100/20', text: isDark ? 'text-blue-400' : 'text-blue-600' }}
                  gradient="from-blue-500 to-cyan-500"
                />
                <StatCard
                  icon={Clock}
                  label="Work Hours"
                  value={att.totalWorkHours}
                  unit="hrs"
                  sub={`${att.totalOvertime} hrs overtime`}
                  color={{ bg: isDark ? 'bg-purple-300/20' : 'bg-purple-50', text: isDark ? 'text-purple-400' : 'text-purple-600' }}
                  gradient="from-purple-500 to-pink-500"
                />
                <StatCard
                  icon={Calendar}
                  label="Leave Balance"
                  value={leave.leaveBalance}
                  unit="days"
                  sub={`${leave.totalTaken} used (overall)`}
                  color={{ bg: isDark ? 'bg-yellow-300/20' : 'bg-yellow-100/20', text: isDark ? 'text-yellow-300' : 'text-yellow-600' }}
                  gradient="from-yellow-500 to-yellow-500"
                />
              </div>

              {/* Employee Profile Card */}
              <div className={`p-4 mb-6 transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm rounded-2xl sm:p-6 sm:mb-8`}>
                <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
                  <div className="relative">
                    <div className="flex items-center justify-center w-16 h-16 text-xl font-bold text-white rounded-full shadow-lg bg-gradient-to-br from-blue-600 to-cyan-600 sm:w-20 sm:h-20 sm:text-2xl">
                      {userDetails?.user_name?.charAt(0) || 'U'}
                    </div>
                    <div className={`absolute w-4 h-4 bg-green-500 border-2 ${isDark ? 'border-gray-900' : 'border-white'} rounded-full -bottom-1 -right-1 sm:w-5 sm:h-5`}></div>
                  </div>
                  <div className="flex-1 text-center sm:text-left">
                    <h2 className={`text-lg font-bold ${textPrimary} sm:text-xl`}>{userDetails?.user_name || 'Employee'}</h2>
                    <div className="flex flex-wrap justify-center gap-3 mt-1 sm:justify-start sm:gap-4 sm:mt-2">
                      <div className={`flex items-center gap-1 text-xs ${textMuted} sm:gap-2 sm:text-sm`}>
                        <Briefcase size={14} /> {userDetails?.user_department || 'Department'}
                      </div>
                      <div className={`flex items-center gap-1 text-xs ${textMuted} sm:gap-2 sm:text-sm`}>
                        <Award size={14} /> ID: {userDetails?.user_roll || 'N/A'}
                      </div>
                    </div>
                  </div>
                  <div className="w-full sm:w-auto">
                    <div className={`inline-flex items-center justify-center w-full gap-2 px-3 py-1.5 ${scoreColor.bg} rounded-xl sm:px-4 sm:py-2`}>
                      <Star size={14} className={scoreColor.text} />
                      <span className={`text-xs font-medium ${scoreColor.text} sm:text-sm`}>Performance Score</span>
                      <span className={`text-base font-bold ${scoreColor.text} sm:text-lg`}>{attendanceScore}%</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Monthly Overview with Metrics */}
              <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-3 sm:gap-6 sm:mb-8">
                <div className={`p-4 transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm lg:col-span-2 rounded-2xl sm:p-6`}>
                  <div className="flex items-center gap-2 mb-4 sm:mb-6">
                    <TrendingUp size={18} className={isDark ? 'text-blue-400' : 'text-blue-600'} />
                    <h3 className={`text-base font-semibold ${textPrimary} sm:text-lg`}>Range Performance</h3>
                  </div>
                  <div className="space-y-4 sm:space-y-5">
                    <div>
                      <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
                        <span className={textSecondary}>Attendance Rate</span>
                        <span className={`font-semibold ${textPrimary}`}>{att.attendancePct}%</span>
                      </div>
                      <div className={`h-1.5 overflow-hidden rounded-full ${isDark ? 'bg-blue-900/30' : 'bg-gray-200'} sm:h-2`}>
                        <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-green-500 to-teal-500" style={{ width: `${att.attendancePct}%` }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
                        <span className={textSecondary}>Punctuality (on‑time arrivals)</span>
                        <span className={`font-semibold ${textPrimary}`}>{att.onTimePct}%</span>
                      </div>
                      <div className={`h-1.5 overflow-hidden rounded-full ${isDark ? 'bg-blue-900/30' : 'bg-gray-200'} sm:h-2`}>
                        <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500" style={{ width: `${att.onTimePct}%` }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
                        <span className={textSecondary}>Leave Utilization (overall)</span>
                        <span className={`font-semibold ${textPrimary}`}>{Math.min((leave.totalTaken / Math.max(leave.totalTaken + leave.leaveBalance, 1)) * 100, 100).toFixed(1)}%</span>
                      </div>
                      <div className={`h-1.5 overflow-hidden rounded-full ${isDark ? 'bg-blue-900/30' : 'bg-gray-200'} sm:h-2`}>
                        <div className="h-full transition-all duration-1000 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500" style={{ width: `${Math.min((leave.totalTaken / Math.max(leave.totalTaken + leave.leaveBalance, 1)) * 100, 100)}%` }}></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`p-4 text-white transition-all duration-300 shadow-sm bg-gradient-to-br from-blue-700 to-cyan-700 rounded-2xl sm:p-6`}>
                  <div className="flex items-center gap-2 mb-3 sm:mb-4">
                    <Zap size={18} className="text-gray-300 dark:text-blue-200" />
                    <h3 className="text-base font-semibold sm:text-lg">Quick Stats</h3>
                  </div>
                  <div className="space-y-3 sm:space-y-4">
                    <div>
                      <p className="text-xs text-gray-300 dark:text-blue-100 sm:text-sm">Present Days</p>
                      <p className="text-2xl font-bold sm:text-3xl">{att.presentDays} <span className="text-base text-white dark:text-blue-200 sm:text-lg">/ {att.totalDaysConsidered}</span></p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-300 dark:text-blue-100 sm:text-sm">Total Work Hours</p>
                      <p className="text-xl font-bold sm:text-2xl">{att.totalWorkHours} hrs</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-300 dark:text-blue-100 sm:text-sm">Overtime</p>
                      <p className="text-xl font-bold sm:text-2xl">{att.totalOvertime} hrs</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Daily Activity Heatmap */}
              <div className={`p-3 mb-6 transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm rounded-2xl sm:p-4 sm:mb-8 md:p-6`}>
                <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between sm:mb-6">
                  <div className="flex items-center gap-2">
                    <Calendar size={18} className={isDark ? 'text-blue-400' : 'text-blue-600'} />
                    <h3 className={`text-base font-semibold ${textPrimary} sm:text-lg`}>Daily Activity Heatmap</h3>
                  </div>
                  <div className="flex flex-wrap gap-2 text-xs sm:gap-3">
                    <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 rounded bg-green-500"></div><span className={textSecondary}>Present</span></div>
                    <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-red-500 rounded"></div><span className={textSecondary}>Absent</span></div>
                    <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-purple-500 rounded"></div><span className={textSecondary}>Leave</span></div>
                    <div className="flex items-center gap-1"><div className="w-2.5 h-2.5 bg-cyan-500 rounded"></div><span className={textSecondary}>Holiday</span></div>
                    <div className="flex items-center gap-1"><div className={`w-2.5 h-2.5 ${isDark ? 'bg-gray-700' : 'bg-gray-500'} rounded`}></div><span className={textSecondary}>Weekend</span></div>
                    <div className="flex items-center gap-1"><div className={`w-2.5 h-2.5 ${isDark ? 'bg-gray-800' : 'bg-gray-400'} rounded`}></div><span className={textSecondary}>Upcoming</span></div>
                  </div>
                </div>

                {att.dailyData.length === 0 ? (
                  <div className="py-12 text-center">
                    <p className={textSecondary}>No attendance data available for the selected period.</p>
                  </div>
                ) : (
                  <div>
                    <div className="grid grid-cols-7 gap-1 min-w-[280px] sm:gap-1.5 md:gap-2">
                      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                        <div key={day} className={`py-1 text-[10px] font-medium text-center ${textSecondary} sm:py-2 sm:text-xs`}>{day}</div>
                      ))}
                      {(() => {
                        const sortedDays = [...att.dailyData].sort((a, b) => new Date(a.date) - new Date(b.date));
                        if (sortedDays.length === 0) return null;
                        const startDate = new Date(sortedDays[0].date);
                        const blanks = Array(startDate.getDay()).fill(null);
                        const calendarDays = [...blanks, ...sortedDays];
                        return calendarDays.map((d, index) => {
                          if (!d) return <div key={`empty-${index}`} className={`p-1 rounded-lg ${isDark ? 'bg-blue-900/20' : 'bg-gray-100'} sm:p-2`}></div>;
                          const bgColor = getStatusColor(d.status);
                          const statusText = getStatusText(d.status);
                          return (
                            <div
                              key={`day-${d.day}-${index}`}
                              className={`${bgColor} rounded-lg p-1 text-center transition-all duration-200 hover:scale-105 cursor-pointer shadow-sm relative group sm:p-1.5 md:p-2`}
                              onMouseEnter={() => setHoveredDay(d)}
                              onMouseLeave={() => setHoveredDay(null)}
                              onClick={() => setHoveredDay(d)}
                            >
                              <div className="text-xs font-semibold text-white sm:text-sm">{d.day}</div>
                              <div className={`absolute z-10 px-2 py-1 mb-1 text-xs text-white transition-opacity duration-200 transform -translate-x-1/2 bg-gray-900 rounded-lg opacity-0 pointer-events-none bottom-full left-1/2 dark:bg-gray-800 group-hover:opacity-100 whitespace-nowrap`}>
                                {statusText}
                                {d.workHours > 0 && ` • ${d.workHours.toFixed(1)}h`}
                                {d.lateBy && ` • Late: ${d.lateBy}`}
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </div>
                )}

                {/* Hover Details Card */}
                {hoveredDay && (
                  <div className={`p-3 mt-4 border ${isDark ? 'border-blue-800/40 bg-blue-900/20' : 'border-gray-200 bg-gray-50'} rounded-xl animate-fade-in sm:p-4`}>
                    <div className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center sm:justify-between">
                      <p className={`text-sm font-semibold ${textPrimary} sm:text-base`}>
                        {new Date(hoveredDay.date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                      </p>
                      <span className={`self-start px-2 py-0.5 rounded-full text-xs font-medium sm:self-auto ${getStatusBadgeStyle(hoveredDay.status)}`}>
                        {getStatusText(hoveredDay.status)}
                      </span>
                    </div>
                    <div className="grid grid-cols-2 gap-3 mt-3 text-sm sm:grid-cols-4">
                      {hoveredDay.inTime && (
                        <div className="flex items-center gap-2">
                          <Clock size={14} className={isDark ? 'text-gray-400' : 'text-gray-500'} />
                          <div>
                            <p className={`text-xs ${textSecondary}`}>Check In</p>
                            <p className={`font-medium ${textLight}`}>{hoveredDay.inTime}</p>
                          </div>
                        </div>
                      )}
                      {hoveredDay.outTime && (
                        <div className="flex items-center gap-2">
                          <Clock size={14} className={isDark ? 'text-gray-400' : 'text-gray-500'} />
                          <div>
                            <p className={`text-xs ${textSecondary}`}>Check Out</p>
                            <p className={`font-medium ${textLight}`}>{hoveredDay.outTime}</p>
                          </div>
                        </div>
                      )}
                      {hoveredDay.workHours > 0 && (
                        <div className="flex items-center gap-2">
                          <TrendingUp size={14} className={isDark ? 'text-gray-400' : 'text-gray-500'} />
                          <div>
                            <p className={`text-xs ${textSecondary}`}>Work Hours</p>
                            <p className={`font-medium ${textLight}`}>{hoveredDay.workHours.toFixed(1)}h</p>
                          </div>
                        </div>
                      )}
                      {hoveredDay.lateBy && (
                        <div className="flex items-center gap-2">
                          <AlertCircle size={14} className="text-yellow-500" />
                          <div>
                            <p className={`text-xs ${textSecondary}`}>Late By</p>
                            <p className="font-medium text-yellow-600 dark:text-yellow-400">{hoveredDay.lateBy}</p>
                          </div>
                        </div>
                      )}
                    </div>
                    {hoveredDay.remark && (
                      <div className={`pt-3 mt-3 border-t ${isDark ? 'border-blue-800/40' : 'border-gray-200'}`}>
                        <p className={`mb-1 text-xs ${textSecondary}`}>Remark</p>
                        <p className={`text-sm ${textLight}`}>{hoveredDay.remark}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Weekly Pattern & Leave Summary */}
              <div className="grid grid-cols-1 gap-4 mb-6 lg:grid-cols-2 sm:gap-6 sm:mb-8">
                <div className={`p-4 transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm rounded-2xl sm:p-6`}>
                  <div className="flex items-center gap-2 mb-4 sm:mb-6">
                    <PieChart size={18} className={isDark ? 'text-blue-400' : 'text-blue-600'} />
                    <h3 className={`text-base font-semibold ${textPrimary} sm:text-lg`}>Weekly Pattern</h3>
                  </div>
                  <div className="space-y-3 sm:space-y-4">
                    {Object.entries(weekly).map(([day, data]) => (
                      <div key={day}>
                        <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
                          <span className={`font-medium ${textLight}`}>{day}</span>
                          <span className={textSecondary}>{data.present} days • {data.late} late</span>
                        </div>
                        <div className={`h-1.5 overflow-hidden rounded-full ${isDark ? 'bg-blue-900/30' : 'bg-gray-200'} sm:h-2`}>
                          <div className="h-full transition-all rounded-full bg-gradient-to-r from-blue-500 to-cyan-500" style={{ width: `${Math.min((data.present / 5) * 100, 100)}%` }}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className={`p-4 transition-all duration-300 ${bgCard} border ${borderColor} shadow-sm rounded-2xl sm:p-6`}>
                  <div className="flex items-center gap-2 mb-4 sm:mb-6">
                    <Calendar size={18} className={isDark ? 'text-blue-400' : 'text-blue-600'} />
                    <h3 className={`text-base font-semibold ${textPrimary} sm:text-lg`}>Leave Breakdown</h3>
                  </div>
                  <div className="space-y-3 sm:space-y-4">
                    {Object.entries(leave.byType).map(([type, days]) => days > 0 && (
                      <div key={type}>
                        <div className="flex justify-between mb-1 text-xs sm:mb-2 sm:text-sm">
                          <span className={textLight}>{type}</span>
                          <span className={`font-semibold ${textPrimary}`}>{days} days</span>
                        </div>
                        <div className={`h-1.5 overflow-hidden rounded-full ${isDark ? 'bg-blue-900/30' : 'bg-gray-200'} sm:h-2`}>
                          <div className="h-full rounded-full bg-gradient-to-r from-blue-400 to-cyan-500" style={{ width: `${Math.min((days / 20) * 100, 100)}%` }}></div>
                        </div>
                      </div>
                    ))}
                    <div className={`pt-3 mt-3 border-t ${isDark ? 'border-blue-800/40' : 'border-gray-200'} sm:pt-4 sm:mt-4`}>
                      <div className="flex justify-between text-xs sm:text-sm">
                        <span className={textSecondary}>Pending Requests</span>
                        <span className="font-semibold text-yellow-600 dark:text-yellow-400">{leave.pendingCount}</span>
                      </div>
                      <div className="flex justify-between mt-1 text-xs sm:mt-2 sm:text-sm">
                        <span className={textSecondary}>Approved Requests</span>
                        <span className="font-semibold text-green-600 dark:text-green-400">{leave.approvedCount}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Alerts */}
              {att.lateDays > 3 && (
                <div className={`p-3 mb-4 transition-all duration-300 border ${alertWarning} rounded-2xl sm:p-4 sm:mb-6`}>
                  <div className="flex gap-2 sm:gap-3">
                    <Bell className={`flex-shrink-0 w-4 h-4 ${isDark ? 'text-red-400' : 'text-red-600'} sm:w-5 sm:h-5`} />
                    <div>
                      <h4 className={`mb-0.5 text-sm font-semibold ${isDark ? 'text-red-300' : 'text-red-800'} sm:mb-1 sm:text-base`}>Punctuality Alert</h4>
                      <p className={`text-xs ${isDark ? 'text-red-400' : 'text-red-700'} sm:text-sm`}>
                        You've been late {att.lateDays} times in the selected period. Consider adjusting your morning routine.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {att.attendancePct >= 90 && att.lateDays === 0 && att.totalDaysConsidered > 0 && (
                <div className={`p-3 mb-4 transition-all duration-300 border ${alertSuccess} rounded-2xl sm:p-4 sm:mb-6`}>
                  <div className="flex gap-2 sm:gap-3">
                    <Award className={`flex-shrink-0 w-4 h-4 ${isDark ? 'text-green-400' : 'text-green-600'} sm:w-5 sm:h-5`} />
                    <div>
                      <h4 className={`mb-0.5 text-sm font-semibold ${isDark ? 'text-green-300' : 'text-green-800'} sm:mb-1 sm:text-base`}>Outstanding Performance! 🎉</h4>
                      <p className={`text-xs ${isDark ? 'text-green-400' : 'text-green-700'} sm:text-sm`}>
                        Perfect attendance with {att.attendancePct}% rate and zero late marks. Keep it up!
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>  
      </div>
    </div>
  );
};

export default Analytics;
